import type { BetaAccessKey } from '@/hooks/useBetaAccess';

type BetaAccessRbac = {
  selectedSubAccountId: number | null;
  hasBetaAccess: (code: string) => boolean;
};

/**
 * Resolves nav/route permissions that are per-user beta grants rather than role permissions.
 * Returns null for any other permission so the caller falls back to the normal RBAC check
 * (which would wrongly let org owners through for these keys).
 */
export function resolveBetaNavPermission(rbac: BetaAccessRbac, perm: string): boolean | null {
  switch (perm as BetaAccessKey) {
    case 'command_center.view':
      return rbac.hasBetaAccess('command_center.view');
    case 'blyn.view':
      // Blyn stays visible inside a sub-tenant only for users who also hold blyn.view_in_subtenant.
      return (
        rbac.hasBetaAccess('blyn.view') &&
        (rbac.selectedSubAccountId == null || rbac.hasBetaAccess('blyn.view_in_subtenant'))
      );
    default:
      return null;
  }
}
